export const STEP_IDS = {
  INSTALL_GUIDE: 'install-guide',
  INSTALLATION_COMPLETE: 'installation-complete',
};

export const INSTALLATION_COMPLETE_TRANSLATION_KEY =
  'dialogs.github-mt-installation.installation-complete';

export const FORM_IDS = {
  INSTALL_GUIDE: 'github-mt-install-guide-form',
};

export const GITHUB_MT_ERROR_CODES = {
  STATE_EXPIRED: 'STATE_EXPIRED',
  STATE_ERROR: 'STATE_ERROR',
  DUPLICATE_INSTALLATION: 'DUPLICATE_INSTALLATION',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  INSTALLATION_REQUEST_PENDING: 'INSTALLATION_REQUEST_PENDING',
  INSTALLATION_CREDENTIALS_INVALID: 'INSTALLATION_CREDENTIALS_INVALID',
  GITHUB_ID_ALREADY_CLAIMED: 'GITHUB_ID_ALREADY_CLAIMED',
} as const;

export const MARKETPLACE_STATE_TTL_MS = 50 * 60 * 1000;

export const MARKETPLACE_ERROR_CODES = {
  MARKETPLACE_STATE_EXPIRED: 'MARKETPLACE_STATE_EXPIRED',
  MARKETPLACE_STATE_MISMATCH: 'MARKETPLACE_STATE_MISMATCH',
  MARKETPLACE_STATE_ERROR: 'MARKETPLACE_STATE_ERROR',
  INSTALLATION_ALREADY_EXISTS_IN_WORKSPACE:
    'INSTALLATION_ALREADY_EXISTS_IN_WORKSPACE',
  INSTALLATION_OWNED_BY_OTHER_WORKSPACE:
    'INSTALLATION_OWNED_BY_OTHER_WORKSPACE',
  INSTALLATION_CREDENTIALS_INVALID: 'INSTALLATION_CREDENTIALS_INVALID',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  GENERIC: 'GENERIC',
  GITHUB_ID_ALREADY_CLAIMED: 'GITHUB_ID_ALREADY_CLAIMED',
} as const;

export type MarketplaceErrorCode =
  (typeof MARKETPLACE_ERROR_CODES)[keyof typeof MARKETPLACE_ERROR_CODES];

export const MARKETPLACE_PHASES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ALREADY_INSTALLED: 'already-installed',
  ERROR: 'error',
} as const;

export type MarketplacePhase =
  (typeof MARKETPLACE_PHASES)[keyof typeof MARKETPLACE_PHASES];
